 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-Aktuelles-vue":"view-Aktuelles-vue","view-Archiv-vue":"view-Archiv-vue","view-Contact-vue":"view-Contact-vue","view-Dokumente-Archiv-vue":"view-Dokumente-Archiv-vue","view-Dokumente-Finanzausgleich-vue":"view-Dokumente-Finanzausgleich-vue","view-Dokumente-Rechtssammlung-vue":"view-Dokumente-Rechtssammlung-vue","view-Dokumente-Terminlisten-vue":"view-Dokumente-Terminlisten-vue","view-Finanzausgleich-vue":"view-Finanzausgleich-vue","view-InfoSite-vue":"view-InfoSite-vue","view-Kantonskirchenrat-Buero-vue":"view-Kantonskirchenrat-Buero-vue","view-Kantonskirchenrat-Ersatzmitglieder_Kirchenrat-vue":"view-Kantonskirchenrat-Ersatzmitglieder_Kirchenrat-vue","view-Kantonskirchenrat-Kommissionen-vue":"view-Kantonskirchenrat-Kommissionen-vue","view-Kantonskirchenrat-Protokolle-detailed-vue":"view-Kantonskirchenrat-Protokolle-detailed-vue","view-Kantonskirchenrat-Protokolle-vue":"view-Kantonskirchenrat-Protokolle-vue","view-Dokumente-vue":"view-Dokumente-vue","view-Kantonskirchenrat-vue":"view-Kantonskirchenrat-vue","view-Organisation-vue":"view-Organisation-vue","view-Protokolle-vue":"view-Protokolle-vue","view-Kantonskirchenrat-Verzeichnis_der_Mitglieder-vue":"view-Kantonskirchenrat-Verzeichnis_der_Mitglieder-vue","view-Kantonskirchenrat-Vorberatenden_Kommission_Gesetzte-vue":"view-Kantonskirchenrat-Vorberatenden_Kommission_Gesetzte-vue","view-KirchenVostand-vue":"view-KirchenVostand-vue","view-KirchengemeindenTable-vue":"view-KirchengemeindenTable-vue","view-Kirchenvorstand-vue":"view-Kirchenvorstand-vue","view-Kirchgemeinden-vue":"view-Kirchgemeinden-vue","view-Links-vue":"view-Links-vue","view-Mustervorlagen-vue":"view-Mustervorlagen-vue","view-News-vue":"view-News-vue","view-Pfarreien-vue":"view-Pfarreien-vue","view-PraesidentInnen-vue":"view-PraesidentInnen-vue","view-Rechenschaftsberichte-vue":"view-Rechenschaftsberichte-vue","view-Rechtssammlung-vue":"view-Rechtssammlung-vue","view-Rekurskommission-vue":"view-Rekurskommission-vue","view-Sekretariat-vue":"view-Sekretariat-vue","view-Terminlisten-vue":"view-Terminlisten-vue","view-infoSite-VoteTable-vue":"view-infoSite-VoteTable-vue"}[chunkId]||chunkId) + "." + {"view-Aktuelles-vue":"e2d57847","view-Archiv-vue":"ef94502c","view-Contact-vue":"bf6a381b","view-Dokumente-Archiv-vue":"8e2161d2","view-Dokumente-Finanzausgleich-vue":"b17d7dc0","view-Dokumente-Rechtssammlung-vue":"abbaac38","view-Dokumente-Terminlisten-vue":"5a860cb4","view-Finanzausgleich-vue":"a52e2282","view-InfoSite-vue":"fb6791fe","view-Kantonskirchenrat-Buero-vue":"718095ec","view-Kantonskirchenrat-Ersatzmitglieder_Kirchenrat-vue":"93975503","view-Kantonskirchenrat-Kommissionen-vue":"c260cc0a","view-Kantonskirchenrat-Protokolle-detailed-vue":"f28c60f8","view-Kantonskirchenrat-Protokolle-vue":"7b30f319","view-Dokumente-vue":"c3f09dc9","view-Kantonskirchenrat-vue":"348e0fcf","view-Organisation-vue":"64a65227","view-Protokolle-vue":"3611a200","view-Kantonskirchenrat-Verzeichnis_der_Mitglieder-vue":"873610e5","view-Kantonskirchenrat-Vorberatenden_Kommission_Gesetzte-vue":"4a6db127","view-KirchenVostand-vue":"15821653","view-KirchengemeindenTable-vue":"85c9b676","view-Kirchenvorstand-vue":"32de8050","view-Kirchgemeinden-vue":"eacb68d3","view-Links-vue":"ae3ef68b","view-Mustervorlagen-vue":"216f7ae6","view-News-vue":"9261a8f7","view-Pfarreien-vue":"0edebf9d","view-PraesidentInnen-vue":"94feb791","view-Rechenschaftsberichte-vue":"c88e5ea0","view-Rechtssammlung-vue":"bc5172e4","view-Rekurskommission-vue":"6be81727","view-Sekretariat-vue":"16192f11","view-Terminlisten-vue":"efd6dcb0","view-infoSite-VoteTable-vue":"ab717414"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-Kantonskirchenrat-Protokolle-vue":1,"view-Organisation-vue":1,"view-PraesidentInnen-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-Aktuelles-vue":"view-Aktuelles-vue","view-Archiv-vue":"view-Archiv-vue","view-Contact-vue":"view-Contact-vue","view-Dokumente-Archiv-vue":"view-Dokumente-Archiv-vue","view-Dokumente-Finanzausgleich-vue":"view-Dokumente-Finanzausgleich-vue","view-Dokumente-Rechtssammlung-vue":"view-Dokumente-Rechtssammlung-vue","view-Dokumente-Terminlisten-vue":"view-Dokumente-Terminlisten-vue","view-Finanzausgleich-vue":"view-Finanzausgleich-vue","view-InfoSite-vue":"view-InfoSite-vue","view-Kantonskirchenrat-Buero-vue":"view-Kantonskirchenrat-Buero-vue","view-Kantonskirchenrat-Ersatzmitglieder_Kirchenrat-vue":"view-Kantonskirchenrat-Ersatzmitglieder_Kirchenrat-vue","view-Kantonskirchenrat-Kommissionen-vue":"view-Kantonskirchenrat-Kommissionen-vue","view-Kantonskirchenrat-Protokolle-detailed-vue":"view-Kantonskirchenrat-Protokolle-detailed-vue","view-Kantonskirchenrat-Protokolle-vue":"view-Kantonskirchenrat-Protokolle-vue","view-Dokumente-vue":"view-Dokumente-vue","view-Kantonskirchenrat-vue":"view-Kantonskirchenrat-vue","view-Organisation-vue":"view-Organisation-vue","view-Protokolle-vue":"view-Protokolle-vue","view-Kantonskirchenrat-Verzeichnis_der_Mitglieder-vue":"view-Kantonskirchenrat-Verzeichnis_der_Mitglieder-vue","view-Kantonskirchenrat-Vorberatenden_Kommission_Gesetzte-vue":"view-Kantonskirchenrat-Vorberatenden_Kommission_Gesetzte-vue","view-KirchenVostand-vue":"view-KirchenVostand-vue","view-KirchengemeindenTable-vue":"view-KirchengemeindenTable-vue","view-Kirchenvorstand-vue":"view-Kirchenvorstand-vue","view-Kirchgemeinden-vue":"view-Kirchgemeinden-vue","view-Links-vue":"view-Links-vue","view-Mustervorlagen-vue":"view-Mustervorlagen-vue","view-News-vue":"view-News-vue","view-Pfarreien-vue":"view-Pfarreien-vue","view-PraesidentInnen-vue":"view-PraesidentInnen-vue","view-Rechenschaftsberichte-vue":"view-Rechenschaftsberichte-vue","view-Rechtssammlung-vue":"view-Rechtssammlung-vue","view-Rekurskommission-vue":"view-Rekurskommission-vue","view-Sekretariat-vue":"view-Sekretariat-vue","view-Terminlisten-vue":"view-Terminlisten-vue","view-infoSite-VoteTable-vue":"view-infoSite-VoteTable-vue"}[chunkId]||chunkId) + "." + {"view-Aktuelles-vue":"31d6cfe0","view-Archiv-vue":"31d6cfe0","view-Contact-vue":"31d6cfe0","view-Dokumente-Archiv-vue":"31d6cfe0","view-Dokumente-Finanzausgleich-vue":"31d6cfe0","view-Dokumente-Rechtssammlung-vue":"31d6cfe0","view-Dokumente-Terminlisten-vue":"31d6cfe0","view-Finanzausgleich-vue":"31d6cfe0","view-InfoSite-vue":"31d6cfe0","view-Kantonskirchenrat-Buero-vue":"31d6cfe0","view-Kantonskirchenrat-Ersatzmitglieder_Kirchenrat-vue":"31d6cfe0","view-Kantonskirchenrat-Kommissionen-vue":"31d6cfe0","view-Kantonskirchenrat-Protokolle-detailed-vue":"31d6cfe0","view-Kantonskirchenrat-Protokolle-vue":"a2129bd0","view-Dokumente-vue":"31d6cfe0","view-Kantonskirchenrat-vue":"31d6cfe0","view-Organisation-vue":"9eb853f4","view-Protokolle-vue":"31d6cfe0","view-Kantonskirchenrat-Verzeichnis_der_Mitglieder-vue":"31d6cfe0","view-Kantonskirchenrat-Vorberatenden_Kommission_Gesetzte-vue":"31d6cfe0","view-KirchenVostand-vue":"31d6cfe0","view-KirchengemeindenTable-vue":"31d6cfe0","view-Kirchenvorstand-vue":"31d6cfe0","view-Kirchgemeinden-vue":"31d6cfe0","view-Links-vue":"31d6cfe0","view-Mustervorlagen-vue":"31d6cfe0","view-News-vue":"31d6cfe0","view-Pfarreien-vue":"31d6cfe0","view-PraesidentInnen-vue":"aeeebb36","view-Rechenschaftsberichte-vue":"31d6cfe0","view-Rechtssammlung-vue":"31d6cfe0","view-Rekurskommission-vue":"31d6cfe0","view-Sekretariat-vue":"31d6cfe0","view-Terminlisten-vue":"31d6cfe0","view-infoSite-VoteTable-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
